export const SWISS_BLACK = 'SwissBlack'
export const SWISS_BOLD = 'SwissBold'
export const ALDINE = 'Aldine'
export const ALIKE = 'Alike'
export const TIMES = 'Times New Roman'
